import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'statusPopup',
  props: {
    content: {
        type: String,
        default: () => ''
    },
    isLoading: {
        type: Boolean,
        default: () => false
    },
    isShowSuccess: {
        type: Boolean,
        default: () => false
    }
},
  setup(__props, { expose: __expose }) {

const show = ref(false)

const props = __props
const open = () => {
    show.value = true
    setTimeout(() => {
        show.value = false
    }, 1000)
}
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    style: {
        minWidth: '30%',
        minHeight: '5%',
        background: '#000000cc',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        padding: '10px 15px',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        zIndex: '10002'
    }
  }, {
    default: _withCtx(() => [
      (props.isLoading)
        ? (_openBlock(), _createBlock(_component_van_loading, { key: 0 }))
        : _createCommentVNode("", true),
      (props.isShowSuccess)
        ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 1,
            name: "success",
            size: "40"
          }))
        : _createCommentVNode("", true),
      (!props.isShowSuccess && !props.isLoading)
        ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 2,
            name: "fail",
            size: "40"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(props.content)), 1)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})